<template>
  <SubscriptionFeaturesContext>
    <BoxesContext>
      <RouterView></RouterView>
    </BoxesContext>
  </SubscriptionFeaturesContext>
</template>

<script setup lang="ts">
import SubscriptionFeaturesContext from '@/components/deepadmin/subscription/SubscriptionFeaturesContext.vue'
import BoxesContext from '@/components/deepbox/boxes/BoxesContext.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.deepbox.boxes',
  },
})
</script>
